import React from "react";
import BlogStyle from "../../../assets/stylesheets/blog/BlogDetail.module.css";
import SignupForm from "../../../layouts/SignupForm";
import FooterStyle from "../../../assets/stylesheets/Footer.module.css";
import AppStyle from "../../../assets/stylesheets/App.module.css";
import WPPostsPage from "../blog-categories/WPPostsPage";  
import { useNavigate } from "react-router-dom";
import slugify from "slugify";

// Local blog images
import MaerketMain from "../../../assets/img/blog/vancouver-main.webp";
import Vancouver from "../../../assets/img/blog/01vancouver-christmas.webp";
import Heritage from "../../../assets/img/blog/05heritage-christmas.webp";
import Yuletide from "../../../assets/img/blog/03yuletide-market.webp";
import Shipyards from "../../../assets/img/blog/02shipyards-christmas.webp";
import Eastside from "../../../assets/img/blog/04eastside.webp";

// Manual farm data with name, location, date, time
const FARMS_DATA = [
  {
    id: 1,
    name: 'Vancouver Christmas Market',
    location: 'Jack Poole Plaza, Vancouver, BC',
    date: 'Nov 13 – Dec 24, 2025',
    time: 'Check the official website',
    description: 'This traditional German-style market features over 90 artisan stalls, festive lights, and European treats like Glühwein and Bratwurst. It transforms downtown Vancouver into a charming winter village, perfect for families and friends.',
    img: Vancouver,
    url: 'https://www.vancouverchristmasmarket.com/'
  },
  {
    id: 2,
    name: 'Shipyards Christmas Market (North Vancouver)',
    location: 'The Shipyards, North Vancouver, BC',
    date: 'Nov 28 – Dec 24, 2025',
    time: 'Weekdays 11:00–21:00 / Weekends 11:00–22:00',
    description: 'Set along the waterfront, this market offers 100+ artisan booths, an outdoor ice rink, and festive lights. Free admission and lively atmosphere make it ideal for families and friends.',
    img: Shipyards,
    url: 'https://www.vancouversnorthshore.com/signatureevent/shipyards-christmas-market/'
  },
  {
    id: 3,
    name: 'Yuletide Market (Victoria)',
    location: 'Bilston Creek Farm, Victoria, BC',
    date: 'November 2025: 21, 22, 23, 28, 29, 30\nDecember 2025: 5, 6, 7, 12, 13, 14, 15, 16, 17, 18, 19, 20, 21',
    time: 'Check the official website',
    description: 'A cozy farm market with outdoor cabins, bonfires, live music, and handcrafted gifts. Perfect for a weekend getaway to enjoy a rustic and festive Christmas experience.',
    img: Yuletide,
    url: ''
  },
  {
    id: 4,
    name: 'Eastside Flea Holiday Markets',
    location: 'Eastside Studios, Vancouver, BC',
    date: 'Nov 28–30 & Dec 5–7, 2025',
    time: 'Fri 17:00–22:00 / Sat & Sun 11:00–17:00',
    description: 'This trendy market features 50+ local artisans, vintage items, food trucks, and live music. Ideal for young adults and couples seeking a hip and lively holiday vibe.',
    img: Eastside,
    url: 'https://www.eastsideflea.com/'
  },
  {
    id: 5,
    name: 'Heritage Christmas at Burnaby Village',
    location: 'Burnaby Village Museum, Burnaby, BC',
    date: 'Nov 29, 2025 – Jan 1, 2026',
    time: 'Check the official website',
    description: 'A historic village decorated with millions of lights, offering a Christmas market, rides, and live entertainment. Perfect for a family-friendly full day of holiday fun.',
    img: Heritage,
    url: 'https://www.burnabyvillagemuseum.ca/'
  }
];

// Reusable Best-of component (renders the list once)
function BestOfList({ className = "" }) {
  return (
    <div className={`${BlogStyle["card-left"]} ${className}`}>
      <div className={BlogStyle["car-title"]}>All our Best of lists</div>
      <div className={BlogStyle["related-subtitle"]}>Christmas</div>
      <ul className={BlogStyle["related-list"]}>
        <li><a href="https://farmciti.com/farm/233/thunderbird-farm">Thunderbird Farm</a></li>
        <li><a href="https://farmciti.com/farm/4/kustermans-adventure-farm">Kustermans Adventure Farm</a></li>
        <li><a href="https://farmciti.com/farm/181/wayne-gretzky-estates">Wayne Gretzky Estates</a></li>
        <li><a href="https://farmciti.com/farm/129/peller-estates-winery-and-restaurant">Peller Estates Winery & Restaurant</a></li>
        <li><a href="https://farmciti.com/farm/180/trius-winery-and-restaurant">Trius Winery & Restaurant</a></li>
        <li><a href="https://farmciti.com/farm/126/the-hare-wine-co">The Hare Wine Co.</a></li>
        <li><a href="https://farmciti.com/farm/176/ravine-vineyard-estate-winery">Ravine Vineyard Estate Winery</a></li>
        <li><a href="https://farmciti.com/farm/144/closson-chase">Closson Chase</a></li>
        <li><a href="https://farmciti.com/farm/170/norman-hardie-winery-and-vineyard">Norman Hardie Winery</a></li>
        <li><a href="https://farmciti.com/farm/62/niemi-family-farm">Niemi Family Farm</a></li>
      </ul>
    </div>
  );
}

export default function VancouverChristmasMarketsBlogPage() {
  const [showTopAd, setShowTopAd] = React.useState(true);
  const navigate = useNavigate();
  const [expandedCards, setExpandedCards] = React.useState({}); // 카드별 확장 상태
  const [overflowingCards, setOverflowingCards] = React.useState({}); // 실제로 overflow된 카드 추적
  const [isMobile, setIsMobile] = React.useState(false);
  const descriptionRefs = React.useRef({}); // 각 description element 참조

  // Use static farm data instead of API calls
  const [items, setItems] = React.useState(FARMS_DATA);
  const [loadingItems, setLoadingItems] = React.useState(true); // Start with loading state
  const [imgLoaded, setImgLoaded] = React.useState({});
  const markLoaded = (idx) => setImgLoaded((p) => ({ ...p, [idx]: true }));

  const toggleCardExpansion = (cardId) => {
    setExpandedCards(prev => ({
      ...prev,
      [cardId]: !prev[cardId]
    }));
  };

  // Simulate loading for static data
  React.useEffect(() => {
    const timer = setTimeout(() => {
      setLoadingItems(false);
    }, 1500); // 1.5 second loading simulation
    
    return () => clearTimeout(timer);
  }, []);

  // Check if mobile on mount and resize
  React.useEffect(() => {
    const checkMobile = () => {
      setIsMobile(window.innerWidth <= 768);
    };
    
    checkMobile();
    window.addEventListener('resize', checkMobile);
    
    return () => window.removeEventListener('resize', checkMobile);
  }, []);

  // Check which descriptions are actually overflowing (truncated with ...) - for desktop only
  React.useEffect(() => {
    if (!loadingItems && !isMobile) {
      const newOverflowingCards = {};
      items.forEach((item) => {
        const element = descriptionRefs.current[item.id];
        if (element) {
          // Check if element is being clamped (scrollHeight > clientHeight)
          const isOverflowing = element.scrollHeight > element.clientHeight;
          newOverflowingCards[item.id] = isOverflowing;
        }
      });
      setOverflowingCards(newOverflowingCards);
    }
  }, [loadingItems, items, isMobile]);

  // Skeleton card component for loading state
  const renderSkeletonCard = (idx) => (
    <div key={`skeleton-${idx}`} className={`${BlogStyle["market-card"]} ${BlogStyle["card-skeleton"]}`}>
      <div className={BlogStyle['card-img-container']}>
        <div className={BlogStyle["card-img-skeleton-static"]} style={{ height: '200px' }} />
      </div>
      <div className={BlogStyle["market-card-content"]}>
        <div className={BlogStyle["market-card-header"]}>
          <span className={BlogStyle["badge-number-skeleton"]} style={{ width: '40px', height: '40px', borderRadius: '12px' }} aria-hidden="true" />
          <div className={BlogStyle["card-title-skeleton"]} style={{ width: '70%', height: '24px' }} aria-hidden="true" />
        </div>
        <div className={BlogStyle["market-card-meta"]}>
          <div className={BlogStyle["market-meta-item"]}>
            <div className={BlogStyle["card-desc-skeleton"]} style={{ width: '16px', height: '16px', borderRadius: '2px' }} />
            <div className={BlogStyle["card-desc-skeleton"]} style={{ width: '60%', height: '14px' }} />
          </div>
          <div className={BlogStyle["market-meta-item"]}>
            <div className={BlogStyle["card-desc-skeleton"]} style={{ width: '16px', height: '16px', borderRadius: '2px' }} />
            <div className={BlogStyle["card-desc-skeleton"]} style={{ width: '80%', height: '14px' }} />
          </div>
          <div className={BlogStyle["market-meta-item"]}>
            <div className={BlogStyle["card-desc-skeleton"]} style={{ width: '16px', height: '16px', borderRadius: '2px' }} />
            <div className={BlogStyle["card-desc-skeleton"]} style={{ width: '50%', height: '14px' }} />
          </div>
        </div>
        <div className={BlogStyle["card-desc-skeleton-group"]} aria-hidden="true" style={{ marginTop: 'var(--gap-sm)' }}>
          <div className={BlogStyle["card-desc-skeleton"]} style={{ width: '95%' }} />
          <div className={BlogStyle["card-desc-skeleton"]} style={{ width: '88%' }} />
          <div className={BlogStyle["card-desc-skeleton"]} style={{ width: '75%' }} />
        </div>
      </div>
    </div>
  );

  return (
    <article className={BlogStyle["page"]}>
      {/* Top banner advertisement under header */}
      {/* {showTopAd && (
        <section className={BlogStyle["top-ad"]} role="complementary" aria-label="Advertisement">
          <button
            type="button"
            className={BlogStyle["top-ad-close"]}
            aria-label="Close advertisement"
            onClick={() => setShowTopAd(false)}
          >
            ×
          </button>
          <img
            className={BlogStyle["top-ad-img"]}
            src="https://images.unsplash.com/photo-1519710164239-da123dc03ef4?q=80&w=1920&auto=format&fit=crop"
            alt="Sponsored banner"
          />
          <div className={BlogStyle["top-ad-overlay"]}>
            <a
              className={BlogStyle["top-ad-btn"]}
              href="https://www.example.com"
              target="_blank"
              rel="noopener sponsored"
            >
              Search homes
            </a>
          </div>
        </section>
      )} */}

      {/* Top meta like blogTO */}
      <div className={BlogStyle["top-meta"]}>
        {/* <span className={BlogStyle["category-name"]}>Best of Winter</span>
        <span className={BlogStyle["sep"]}>•</span>
        <span>FarmCiti Team</span>
        <span className={BlogStyle["sep"]}>•</span>
        <span>Posted today</span> */}
      </div>

      {/* Big title */}
      <h1 className={BlogStyle["title"]}>Best 5 Christmas Markets near Vancouver 2025</h1>

      {/* Hero image */}
      <div className={BlogStyle["hero-wrap"]}>
        <img
          className={BlogStyle["hero"]}
          src={MaerketMain}
          alt="Winter farm hero"
        />
      </div>

      {/* Main body under hero with gap, using left sidebar layout */}
      <section className={BlogStyle["content-wrap-left"]}>
        {/* Sidebar on the left */}
        <aside className={`${BlogStyle["sidebar"]} ${BlogStyle["sidebar-left"]}`}>
          {/* <div className={BlogStyle["ad-box"]} role="complementary" aria-label="Advertisement">
            <img className={BlogStyle["ad-media"]} src={AD02} alt="Advertisement" />
          </div> */}

          <div className={BlogStyle["newsletter"]}>
            <div className={FooterStyle["footer-column"]}>
              <SignupForm />
            </div>
          </div>

          <div className={BlogStyle["hr"]} />

          {/* Desktop/Tablet: show in sidebar */}
          <BestOfList className={BlogStyle["bestof-desktop"]} />
        </aside>

        {/* Main content on the right */}
        <main className={BlogStyle["content"]}>
          <p className={BlogStyle["lead"]}>
            Discover the best Christmas markets near Vancouver in 2025! From festive lights and artisan stalls to family-friendly winter fun, explore Vancouver, North Vancouver, Victoria, and Burnaby holiday markets.<br/><br/>
            Looking for magical holiday experiences this season? From twinkling lights and festive treats to unique artisan gifts, these Christmas markets near Vancouver 2025 are perfect for making unforgettable family memories. Whether you’re exploring downtown Vancouver or taking a weekend trip to Victoria, these winter markets offer seasonal fun for everyone.<br/><br/>
            ✨ Save this list for the ultimate guide to the best Vancouver Christmas markets in 2025.
  
          </p>
          
          <div className={BlogStyle["hr"]} />
          {/* Market cards with new design */}
          <div className={BlogStyle["market-grid"]}>
            {loadingItems ? (
              // Show skeleton cards while loading
              Array.from({ length: 8 }, (_, index) => renderSkeletonCard(index))
            ) : (
              // Show actual market cards when loaded
              items.map((item, index) => {
                const isExpanded = expandedCards[item.id];
                // 모바일: 모든 카드에 버튼 표시, 웹: overflow된 카드만 버튼 표시
                const needsExpansion = isMobile || overflowingCards[item.id] === true;
                
                return (
                  <div key={`market-${item.id}`} className={BlogStyle["vancouver-market-card"]}>
                    <div className={BlogStyle['card-img-container']}>
                      <img
                        className={BlogStyle["vancouver-market-card-image"]}
                        src={item.img || "/assets-placeholder/no-image.png"}
                        alt={item.name || `Market ${index + 1}`}
                        loading="lazy"
                        decoding="async"
                        onLoad={() => setImgLoaded(prev => ({ ...prev, [index]: true }))}
                        onError={(e) => { e.currentTarget.src = '/assets-placeholder/no-image.png'; setImgLoaded(prev => ({ ...prev, [index]: true })); }}
                      />
                      {!imgLoaded[index] && <div className={BlogStyle["card-img-skeleton"]} />}
                    </div>
                    
                    <div className={BlogStyle["market-card-content"]}>
                      <div className={BlogStyle["market-card-header"]}>
                        <span className={BlogStyle["market-badge-number"]}>{index + 1}</span>
                        <h2 className={BlogStyle["market-card-title"]}>{item.name}</h2>
                      </div>
                      
                      <div className={BlogStyle["market-card-meta"]}>
                        <div className={BlogStyle["market-meta-item"]}>
                          <svg className={BlogStyle["market-meta-icon"]} fill="none" stroke="currentColor" viewBox="0 0 24 24">
                            <path strokeLinecap="round" strokeLinejoin="round" strokeWidth={2} d="M17.657 16.657L13.414 20.9a1.998 1.998 0 01-2.827 0l-4.244-4.243a8 8 0 1111.314 0z" />
                            <path strokeLinecap="round" strokeLinejoin="round" strokeWidth={2} d="M15 11a3 3 0 11-6 0 3 3 0 016 0z" />
                          </svg>
                          <span className={BlogStyle["market-meta-location"]}>{item.location}</span>
                        </div>
                        
                        <div className={BlogStyle["market-meta-item"]}>
                          <svg className={BlogStyle["market-meta-icon"]} fill="none" stroke="currentColor" viewBox="0 0 24 24">
                            <path strokeLinecap="round" strokeLinejoin="round" strokeWidth={2} d="M8 7V3m8 4V3m-9 8h10M5 21h14a2 2 0 002-2V7a2 2 0 00-2-2H5a2 2 0 00-2 2v12a2 2 0 002 2z" />
                          </svg>
                          <span className={BlogStyle["market-meta-date"]}>{item.date}</span>
                        </div>
                        
                        <div className={BlogStyle["market-meta-item"]}>
                          <svg className={BlogStyle["market-meta-icon"]} fill="none" stroke="currentColor" viewBox="0 0 24 24">
                            <path strokeLinecap="round" strokeLinejoin="round" strokeWidth={2} d="M12 8v4l3 3m6-3a9 9 0 11-18 0 9 9 0 0118 0z" />
                          </svg>
                          <span className={BlogStyle["market-meta-time"]}>{item.time}</span>
                        </div>
                        
                        {item.url && (
                          <div className={BlogStyle["market-meta-item"]}>
                            <svg className={BlogStyle["market-meta-icon"]} fill="none" stroke="currentColor" viewBox="0 0 24 24">
                              <path strokeLinecap="round" strokeLinejoin="round" strokeWidth={2} d="M13.828 10.172a4 4 0 00-5.656 0l-4 4a4 4 0 105.656 5.656l1.102-1.101m-.758-4.899a4 4 0 005.656 0l4-4a4 4 0 00-5.656-5.656l-1.1 1.1" />
                            </svg>
                            <a 
                              href={item.url} 
                              target="_blank" 
                              rel="noopener noreferrer"
                              className={BlogStyle["market-meta-link"]}
                            >
                              Official Site
                            </a>
                          </div>
                        )}
                      </div>
                      
                      {item.description && (
                        <>
                          <div className={BlogStyle["market-description-wrapper"]}>
                            <p 
                              ref={(el) => descriptionRefs.current[item.id] = el}
                              className={`${BlogStyle["market-card-description"]} ${isExpanded ? BlogStyle["market-description-expanded"] : ""}`}
                            >
                              {item.description}
                            </p>
                          </div>
                          {needsExpansion && (
                            <button 
                              className={BlogStyle["market-expand-btn"]}
                              onClick={() => toggleCardExpansion(item.id)}
                              aria-label={isExpanded ? "접기" : "더보기"}
                            >
                              <svg 
                                className={`${BlogStyle["market-expand-icon"]} ${isExpanded ? BlogStyle["market-expand-icon-rotated"] : ""}`}
                                fill="none" 
                                stroke="currentColor" 
                                viewBox="0 0 24 24"
                              >
                                <path strokeLinecap="round" strokeLinejoin="round" strokeWidth={2} d="M19 9l-7 7-7-7" />
                              </svg>
                            </button>
                          )}
                        </>
                      )}
                    </div>
                  </div>
                );
              })
            )}
          </div>

        </main>

        {/* Mobile: show below items and above map */}
        <BestOfList className={BlogStyle["bestof-mobile"]} />
      </section>

        {/* Map section (Google Maps embed without API) */}
        <div className={BlogStyle["hr"]} />
        <section className={BlogStyle["map-wrap"]} aria-label="Map of Vancouver Christmas markets">
          {/* Crop the My Maps header by shifting the iframe up inside a clipped container */}
          <div className={BlogStyle["map-clip"]}>
            <iframe 
              className={BlogStyle["map-frame"]}
              title="Google Map — Vancouver Christmas markets"
              src="https://www.google.com/maps/d/embed?mid=1mr1CNgTFovHvcTwaveRBQbEJUvFsjRA&ehbc=2E312F&ll=49.25,-123.1&z=10" 
              loading="lazy"
            />
          </div>
        </section>

      {/* Bottom share/ad area */}
      {/* <div className={BlogStyle["hr"]} />
      <div className={BlogStyle["ad-box"]} role="complementary" aria-label="Advertisement">
        <img className={`${BlogStyle["ad-media"]} ${BlogStyle["ad-media-fixed"]}`} src={AD04} alt="Advertisement" />
      </div> */}

      {/* blog section */}
      <section className={`${AppStyle["section"]} ${AppStyle["card-section"]}`}>
        <WPPostsPage />
      </section>
    </article>
  );
}